import { Fragment } from 'react';
import { default as Box } from '@mui/material/Box';
import { Text } from 'components/Text';
import { altPrefix } from '../constants';
import { SizedBox } from './SizedBox';

export const InstructionStep = ({
  textParts,
  imageSrc
}: {
  textParts: string[];
  imageSrc: string;
}) => (
  <SizedBox>
    <Text variant="body2" mb={2}>
      {textParts.map((part, index) => (
        <Fragment key={index}>
          {index % 2 === 1 ? <b>{part}</b> : part}
          &nbsp;
        </Fragment>
      ))}
    </Text>
    <Box mb={2}>
      <img alt={`${altPrefix} ${imageSrc}`} src={imageSrc} />
    </Box>
  </SizedBox>
);
